export default __webpack_public_path__ + "static/media/about-us.e0d56235.svg";